import React from 'react'

import FormControl from '@mui/material/FormControl'
import FormLabel from '@mui/material/FormLabel'
import MuiSlider from '@mui/material/Slider'

interface SliderProps {
  value: number
  label: string
  options: Array<{ id: number; value: number; label: string }>
  onChange: (newValue: number) => void
}

const Slider = (props: SliderProps): JSX.Element => {
  const getTicks = (): Array<{ id: number; value: number; label: string }> => {
    // 16 options -> 5 ticks
    // 17 options -> 5 ticks
    const ticks = props.options.filter((_x, index) => index % 4 === 0)
    if ((props.options.length - 1) % 4 !== 0) {
      ticks.push(props.options[props.options.length - 1])
    }
    return ticks
  }

  return (
    <FormControl sx={{ mb: 3, minWidth: '40%' }}>
      <FormLabel>{props.label}</FormLabel>
      <MuiSlider
        className="cupping-slider"
        sx={{
          height: '1px',
          zIndex: 5,
          ml: { xs: 6, sm: 2 },
          mr: { xs: 6, sm: 2 },
          mt: 1,
          width: 'auto',
        }}
        min={props.options[0].value}
        max={props.options[props.options.length - 1].value}
        step={props.options[1].value - props.options[0].value}
        valueLabelDisplay="auto"
        valueLabelFormat={(value: number): string => {
          return props.options.find((x) => x.value === value)?.label || `${value}`
        }}
        value={props.value}
        marks={getTicks()} // show every 4th value
        onChange={(_event, newValue: number | number[]) => {
          if (typeof newValue === 'number') {
            props.onChange(newValue)
          }
        }}
      />
    </FormControl>
  )
}

export default Slider
